import React, { useEffect, useState } from "react"
import { StaticImage } from "gatsby-plugin-image"

import {
  onClickAddFriend,
  onClickCloseRegistrationModal,
  onViewRegistrationModal,
} from "../utils/hook"
import Space from "./space"
import Text from "./text"
import ButtonFill from "./button-fill"

type Props = {
  utmSource: string
  utmMedium: string
  utmCampaign: string
  utmContent: string
}

const ModalRegistration: React.FC<Props> = ({
  utmSource,
  utmMedium,
  utmCampaign,
  utmContent,
}) => {
  const [isClosed, setClosed] = useState(false)
  const onClose = () => {
    setClosed(true)
    document.body.classList.remove("suppress-scroll")
    onClickCloseRegistrationModal({ utmSource, utmMedium, utmCampaign, utmContent })
  }
  useEffect(() => {
    document.body.classList.add("suppress-scroll")
    onViewRegistrationModal({ utmSource, utmMedium, utmCampaign, utmContent })
  }, [utmSource, utmMedium, utmCampaign])
  return isClosed ? null : (
    <div className="fixed z-30 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen">
        <div className="fixed inset-0 bg-black-alpha-50 transition-opacity"></div>
        <div className="bg-white rounded-xl overflow-hidden shadow-xl transform transition-all w-260px">
          <div className="flex flex-col items-center justify-center p-4">
            <Space sizeY="2" />
            <StaticImage
              src="../images/paircare-icon.png"
              alt="ペアケア"
              placeholder="none"
              width={45}
            />
            <Space sizeY="3" />
            <Text fontBold={true} textCenter={true}>
              LINEで始める体調管理
            </Text>
            <Space sizeY="2" />
            <Text fontSize="sm" textCenter={true}>
              ペアケアをLINEに友だち追加して体調を入力すると、よりパーソナライズされた記事が表示されます。
            </Text>
            <Space sizeY="5" />
            <ButtonFill
              classes="w-full py-3"
              color="green-800"
              onClick={() => {
                onClickAddFriend({ utmSource, utmMedium, utmCampaign, utmContent })
              }}
            >
              <Text fontSize="sm" fontBold={true} color="white">
                友だち追加
              </Text>
            </ButtonFill>
            <Space sizeY="3" />
            <div
              onClick={() => {
                onClose()
              }}
            >
              <Text fontSize="sm">あとで</Text>
            </div>
            <Space sizeY="1" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalRegistration
